"use client"

import { Button } from "@/components/ui/button"
import { PropertyCard } from "@/components/property-card"
import { useFeaturedProperties } from "@/hooks/useProperties"
import { Loader2, AlertCircle, RefreshCw } from "lucide-react"
import Link from "next/link"

export function FeaturedProperties() {
  const { properties, loading, error, refetch } = useFeaturedProperties(4)

  if (loading) {
    return (
      <section id="properties" className="w-full py-16 md:py-24 lg:py-32 bg-raime-dark-blue text-white">
        <div className="container px-4 md:px-6 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">Nuestras Propiedades Destacadas</h2>
          <div className="flex items-center justify-center py-12">
            <Loader2 className="h-8 w-8 animate-spin text-raime-golden-brown" />
            <span className="ml-2 text-lg">Cargando propiedades...</span>
          </div>
        </div>
      </section>
    )
  }

  if (error) {
    return (
      <section id="properties" className="w-full py-16 md:py-24 lg:py-32 bg-raime-dark-blue text-white">
        <div className="container px-4 md:px-6 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">Nuestras Propiedades Destacadas</h2>
          <div className="flex flex-col items-center justify-center py-12 space-y-4">
            <AlertCircle className="h-12 w-12 text-red-400" />
            <p className="text-lg text-red-200">{error}</p>
            <Button
              onClick={refetch}
              variant="outline"
              className="border-raime-golden-brown text-raime-golden-brown hover:bg-raime-golden-brown hover:text-white bg-transparent"
            >
              <RefreshCw className="h-4 w-4 mr-2" />
              Reintentar
            </Button>
          </div>
        </div>
      </section>
    )
  }

  return (
    <section id="properties" className="w-full py-16 md:py-24 lg:py-32 bg-raime-dark-blue text-white">
      <div className="container px-4 md:px-6 text-center">
        <h2 className="text-3xl md:text-4xl font-bold mb-6">Nuestras Propiedades Destacadas</h2>
        <p className="text-lg opacity-90 max-w-3xl mx-auto mb-12">
          Descubre una selección de nuestros mejores pisos y habitaciones en las ciudades más vibrantes de España.
        </p>

        {properties.length === 0 ? (
          <div className="py-12">
            <p className="text-lg text-gray-300">No hay propiedades destacadas disponibles en este momento.</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            {properties.map((property) => (
              <PropertyCard key={property.id} property={property} />
            ))}
          </div>
        )}

        <Link href="/propiedades">
          <Button className="mt-12 bg-raime-golden-brown hover:bg-raime-golden-brown/90 text-white text-lg px-8 py-6 rounded-full shadow-lg transition-all duration-300 transform hover:scale-105">
            Ver Todas las Propiedades
          </Button>
        </Link>
      </div>
    </section>
  )
}
